import React from 'react';
import { motion } from 'framer-motion';
import { PageBanner } from '../components/PageBanner';
import { PromoBanner } from '../components/PromoBanner';
import { BookingCTA } from '../components/BookingCTA';
import { PromoOffers } from '../components/PromoOffers';
const priceCategories = [{
  name: 'Knotless Braids (Standard)',
  description: 'Neat, lightweight, and protective.',
  services: [{
    title: 'Jumbo Knotless (Midback)',
    price: '$120'
  }, {
    title: 'Jumbo Knotless (Waist)',
    price: '$150'
  }, {
    title: 'Jumbo Knotless (Butt)',
    price: '$170'
  }, {
    title: 'Jumbo Knotless (Thigh)',
    price: '$200'
  }, {
    title: 'Jumbo Knotless (Knee)',
    price: '$220'
  }, {
    title: 'Large Knotless (Midback)',
    price: '$150'
  }, {
    title: 'Large Knotless (Waist)',
    price: '$170'
  }, {
    title: 'Large Knotless (Butt)',
    price: '$200'
  }, {
    title: 'Large Knotless (Thigh)',
    price: '$220'
  }, {
    title: 'Large Knotless (Knee)',
    price: '$250'
  }, {
    title: 'Medium Large Knotless (Midback)',
    price: '$170'
  }, {
    title: 'Medium Large Knotless (Waist)',
    price: '$200'
  }, {
    title: 'Medium Large Knotless (Butt)',
    price: '$220'
  }, {
    title: 'Medium Large Knotless (Thigh)',
    price: '$270'
  }, {
    title: 'Medium Large Knotless (Knee)',
    price: '$320'
  }, {
    title: 'Medium Knotless (Midback)',
    price: '$200'
  }, {
    title: 'Medium Knotless (Waist)',
    price: '$230'
  }, {
    title: 'Medium Knotless (Butt)',
    price: '$270'
  }, {
    title: 'Medium Knotless (Thigh)',
    price: '$300'
  }, {
    title: 'Medium Knotless (Knee)',
    price: '$350'
  }]
}, {
  name: 'Small & Extra Small Knotless',
  description: 'Precision braiding for a long-lasting look.',
  services: [{
    title: 'Small Medium Knotless (Midback)',
    price: '$250'
  }, {
    title: 'Small Medium Knotless (Waist)',
    price: '$270'
  }, {
    title: 'Small Medium Knotless (Butt)',
    price: '$300'
  }, {
    title: 'Small Medium Knotless (Thigh)',
    price: '$350'
  }, {
    title: 'Small Medium Knotless (Knee)',
    price: '$400'
  }, {
    title: 'Small Knotless (Midback)',
    price: '$270'
  }, {
    title: 'Small Knotless (Waist)',
    price: '$300'
  }, {
    title: 'Small Knotless (Butt)',
    price: '$350'
  }, {
    title: 'Small Knotless (Thigh)',
    price: '$400'
  }, {
    title: 'Small Knotless (Knee)',
    price: '$450'
  }, {
    title: 'Extra Small Knotless (Midback)',
    price: '$300'
  }, {
    title: 'Extra Small Knotless (Waist)',
    price: '$350'
  }, {
    title: 'Extra Small Knotless (Butt)',
    price: '$400'
  }, {
    title: 'Extra Small Knotless (Thigh)',
    price: '$450'
  }, {
    title: 'Extra Small Knotless (Knee)',
    price: '$500'
  }]
}, {
  name: 'Boho & Specialty Braids',
  description: 'Bohemian and custom styles.',
  services: [{
    title: 'Small Boho Knotless (Bra Length)',
    price: '$300+'
  }, {
    title: 'Small-Medium Boho Knotless (Bra Length)',
    price: '$280+'
  }, {
    title: 'Medium Boho Knotless (Bra Length)',
    price: '$250+'
  }, {
    title: 'Jumbo Boho Knotless (Bra Length, Hair Incl.)',
    price: '$200+'
  }, {
    title: 'Crochet Braids',
    price: '$120+'
  }, {
    title: 'Box Braids',
    price: '$180+'
  }, {
    title: 'Tribal Braids',
    price: '$160+'
  }]
}, {
  name: 'Locs & Maintenance',
  services: [{
    title: 'Loc Maintenance',
    price: '$80+'
  }, {
    title: 'Faux Locs',
    price: '$180+'
  }, {
    title: 'Butterfly Locs',
    price: '$200+'
  }]
}, {
  name: 'Add-ons & Extras',
  services: [{
    title: 'Bohemian Style Add-on',
    price: '$35'
  }, {
    title: 'Blended Colors',
    price: '$20'
  }, {
    title: 'Added Beads',
    price: '$20'
  }, {
    title: 'Ombre',
    price: '$40'
  }, {
    title: 'Extra Length (Jumbo/Med/Small)',
    price: '$40+'
  }]
}];
export function PriceListPage() {
  return <>
      <PageBanner title="Price List" subtitle="Transparent pricing for all our expert braiding and styling services" backgroundImage="https://cdn.magicpatterns.com/uploads/eq1mzaoV7yww71UG5f3y6M/A_close-up_image_of_a_woman_with_sleek_cornrows,_highlighting_detail_and_precision._(2).jpg" data-id="element-550" />
      <PromoBanner data-id="element-551" />
      <PromoOffers data-id="element-552" />

      <section className="py-16 md:py-24 bg-white" data-id="element-553">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-554">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-center mb-16" data-id="element-555">
            <h2 className="font-display text-4xl md:text-5xl text-near-black mb-6" data-id="element-556">
              Full Service Menu
            </h2>
            <p className="text-near-black/60 text-lg max-w-2xl mx-auto font-body" data-id="element-557">
              All prices are starting prices. Final pricing may vary based on
              hair length, thickness, and style complexity.
            </p>
          </motion.div>

          <div className="space-y-16" data-id="element-558">
            {priceCategories.map((category, catIndex) => <motion.div key={category.name} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: catIndex * 0.1
          }} data-id="element-559">
                <div className="mb-8" data-id="element-560">
                  <h3 className="font-display text-3xl text-near-black mb-2" data-id="element-561">
                    {category.name}
                  </h3>
                  {category.description && <p className="text-brand-gold font-body text-sm uppercase tracking-widest font-bold" data-id="element-562">
                      {category.description}
                    </p>}
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-1" data-id="element-563">
                  {category.services.map((service, serviceIndex) => <div key={service.title} className="flex items-center justify-between py-3 border-b border-gray-100 group hover:bg-brand-gold/5 transition-colors px-2 rounded-lg" data-id="element-564">
                      <span className="text-near-black font-medium text-sm md:text-base" data-id="element-565">
                        {service.title}
                      </span>
                      <div className="flex-1 mx-4 border-b border-dotted border-gray-300 min-w-[20px]" data-id="element-566"></div>
                      <span className="text-brand-gold font-bold text-sm md:text-base whitespace-nowrap" data-id="element-567">
                        {service.price}
                      </span>
                    </div>)}
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mt-20 p-8 rounded-3xl bg-near-black text-cream text-center" data-id="element-568">
            <p className="font-display text-2xl mb-4" data-id="element-569">Don't see your style?</p>
            <p className="text-cream/60 mb-8 font-body" data-id="element-570">
              We do custom styles! Send us a photo of what you want for a quote.
            </p>
            <a href="tel:2409217857" className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-brand-gold text-cream font-bold uppercase tracking-widest text-sm hover:bg-white hover:text-near-black transition-all shadow-md" data-id="element-571">
              Get a Custom Quote <span className="text-lg leading-none" data-id="element-572">→</span>
            </a>
          </motion.div>
        </div>
      </section>
      <BookingCTA data-id="element-573" />
    </>;
}